/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Online_Sections_7_Questions_2_AnswerInputs */

const en_gc_search_guides_gridcraft_online_sections_7_questions_2_answer = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Online_Sections_7_Questions_2_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This site currently bundles the official v0.7.0 web build. The upstream project can publish newer releases independently; use the release page to check other versions.`)
};

const zh_gc_search_guides_gridcraft_online_sections_7_questions_2_answer = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Online_Sections_7_Questions_2_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`本站目前内置官方 v0.7.0 网页构建。上游项目可以独立发布新版本，其他版本请查看官方发布页。`)
};

/**
* | output |
* | --- |
* | "This site currently bundles the official v0.7.0 web build. The upstream project can publish newer releases independently; use the release page to check other..." |
*
* @param {Gc_Search_Guides_Gridcraft_Online_Sections_7_Questions_2_AnswerInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_online_sections_7_questions_2_answer = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Online_Sections_7_Questions_2_AnswerInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Online_Sections_7_Questions_2_AnswerInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_online_sections_7_questions_2_answer(inputs)
	return zh_gc_search_guides_gridcraft_online_sections_7_questions_2_answer(inputs)
});
export { gc_search_guides_gridcraft_online_sections_7_questions_2_answer as "gc.search_guides.gridcraft_online.sections.7.questions.2.answer" }